import React from 'react';
import { PauseModal } from '../../../../components/PauseModal';
import { PauseTypography } from '../../../../components/PauseTypography';
import { PauseButton } from '../../../../components/PauseButton';

type PaymentSuccessModalProps = {
  open: boolean,
  onClose: () => any,
}
export const PaymentSuccessModal = ({
  open = false,
  onClose = () => null,
}: PaymentSuccessModalProps) => (
  <PauseModal
    width="15vw"
    open={open}
    onClose={onClose}
  >
    <div css={(theme) => ({
      display: 'grid',
      justifyContent: 'center',
      textAlign: 'center',
      gridAutoFlow: 'rows',
      gridGap: theme.spacing(2),
      padding: theme.spacing(3),
    })}
    >
      <div>
        <PauseTypography variant="title">
          Payment successful!
        </PauseTypography>
      </div>
      <div>
        <PauseTypography>
          Please check your email for an invoice.
          We will auto-deduct the fee from next month onwards.
        </PauseTypography>
      </div>
      <div>
        <PauseButton onClick={onClose}>
          Great!
        </PauseButton>
      </div>
    </div>

  </PauseModal>
);
